import { shallowEqual } from "react-redux";
import { ListFieldsKeys, ListFieldsType, ListFieldsRecordType, myDocumentsListName } from "src/api/config";
import { selectGetStatus, modifiedItemsState, selectItem, selectItems } from "src/modules/spItems/selectors";
import { RootState } from "src/store/rootReducer";
import { useAppSelector } from "./redux";
import { createSelector } from "@reduxjs/toolkit";

const getObjs = <K extends ListFieldsKeys>(state: RootState, list: K) => {
  return state.spitems.elements.obj[list] as Record<number, ListFieldsRecordType[typeof list]>;
};

const itemsSelector = (list: ListFieldsKeys) =>
  createSelector([getObjs], (objs) => {
    if (!objs) return [];
    if (Object.keys(objs).length === 0) return [];

    return modifiedItemsState(objs, list);
  });

export function useGetSelect<T extends ListFieldsKeys>(list: T) {
  let data: ListFieldsType[T][] = useAppSelector((state: RootState) => selectItems(state, list), shallowEqual);
  const status = useAppSelector((state: RootState) => selectGetStatus(state, list));

  return { data, status };
}

export function useGetItemsSelect<T extends ListFieldsKeys>(list: T) {
  const data = useAppSelector((state) => myDocumentsSelector(state, myDocumentsListName));

  const status = useAppSelector((state: RootState) => selectGetStatus(state, list));

  return { data: [], status };
}

export function useGetOneSelect<T extends ListFieldsKeys>(list: T, id: number) {
  let item = useAppSelector((state: RootState) => selectItem(state, list, id)) as ListFieldsType[T];

  return item;
}

export const myDocumentsSelector = itemsSelector(myDocumentsListName);
